const IconArrowRight = () => {
  return (
    <svg id="right-arrow" xmlns="http://www.w3.org/2000/svg" width="12" height="22" viewBox="0 0 12 22">
      <path id="Tracé_24" data-name="Tracé 24" d="M1.353.228A.781.781,0,0,0,.792,0a.781.781,0,0,0-.56.228.768.768,0,0,0,0,1.1L10.087,11,.232,20.672a.768.768,0,0,0,0,1.1.8.8,0,0,0,1.121,0L11.768,11.55a.768.768,0,0,0,0-1.1Z" fill="#777" />
    </svg>
  );
};

export default IconArrowRight;
